import { render, staticRenderFns } from "./ApproveForm.modal.vue?vue&type=template&id=1b2f2cd4&scoped=true&"
import script from "./ApproveForm.modal.vue?vue&type=script&lang=ts&"
export * from "./ApproveForm.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f2cd4",
  null
  
)

export default component.exports